import Image from 'next/image';
import React from 'react';

import { Endpoints } from '@/network';
import { IStore } from '@/utils/interfaces/Store';

interface Props {
  stores: IStore[] | undefined;
}

const StoreCard: React.FC<Props> = ({ stores }) => {
  return (
    <span className='flex'>
      {stores?.map((store, index) => (
        <a
          key={`${store?._id}-${index}`}
          href={store?.link}
          target='_blank'
          rel='noopener noreferrer'
          className='flex flex-col p-1 md:p-1.5 cursor-pointer'
        >
          <div className='bg-black text-white cursor-pointer flex flex-col rounded-lg h-full border border-grayZl-900 overflow-hidden w-[200px] lg:w-[316px]'>
            <div className='relative w-full aspect-[16/9] bg-white'>
              <Image
                src={`${process.env.NEXT_PUBLIC_API_READER_URL}${Endpoints.store.getStoreImage(store._id)}`}
                alt={store.title}
                fill
                className='object-contain p-2 hover:scale-[1.03] transition-transform duration-500'
                sizes='(max-width: 768px) 200px, 316px'
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>

            {/* <div className='flex flex-col items-start gap-3 p-4 bg-grayZl-950 flex-1 justify-between'>
              <div className='flex flex-col items-start gap-1 w-full'>
                <div className='text-white text-sm lg:text-base font-semibold line-clamp-2 min-h-[40px]'>
                  {store?.title}
                </div>
                <div className='text-white text-xs font-thin line-clamp-1'>
                  {store?.subtitle}
                </div>
                <div className='text-primary text-xs font-medium'>
                  {store?.author?.name}
                </div>
                <div className='flex items-center gap-2 mt-1'>
                  <div className='text-white font-semibold text-sm'>
                    {store?.price ? `₹${store?.price?.toLocaleString()}` : ''}
                  </div>
                  <div className='text-[#c7c6cf] line-through text-xs'>
                    {store?.strokedPrice
                      ? `₹${store?.strokedPrice?.toLocaleString()}`
                      : ''}
                  </div>
                </div>
              </div>
              <Button className='flex items-center w-full justify-center gap-2 h-8 rounded-lg bg-white border-none mt-2'>
                <span className='text-black text-xs font-semibold leading-5'>
                  Know More
                </span>
              </Button>
            </div> */}
          </div>
        </a>
      ))}
    </span>
  );
};

export default StoreCard;
